import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Row, Spinner } from "react-bootstrap";
import ArrowRight from "@mui/icons-material/East";
import ArrowLeftOtline from "@mui/icons-material/ArrowLeftOutlined";
import CalendarmonthOutlined from "@mui/icons-material/CalendarMonthOutlined";
import PaymentsOutline from "@mui/icons-material/PaymentOutlined";
import ApiAmusementService from "../../../core/api/api.amusementService";
import { BasketHelper } from "../../../core/utils/BasketHelper";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import SplitNumber from "../_Components/SplitNumber";
import _ from "lodash";
import jalaali from "jalaali-js";
import { useForm, Controller } from "react-hook-form";
import ContextApp from "../../../core/contexts/context.app";
import Select from "react-select";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Swal from "sweetalert2";
import { FormControl, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { tools } from "../../../core/utils/tools";
import SelectComponent from "../_Components/ReactSelectComponent";
import classNames from "classnames";
import {
  IconHourGlass,
  IconPeople,
  IconForbidden,
  IconPhone,
} from "../../../_metronic/css/icons";
import { DateObject } from "react-multi-date-picker";
import { persian } from "../_Components/customLocale";
import SkeletonReserveItem from "./SkeletonReserveItem/SkeletonReserveItem";
import moment from "moment-jalaali";

//var flag = false;
const Tourism = () => {
  const navigate = useNavigate();
  const [amusementGroups, setAmusementGroups] = useState([]);
  // const [flag, setFlag] = useState(false);
  const [amusementGroupsLoadindData, setAmusementGroupsLoadindData] =
    useState(false);
  const [selectedAmusementGroup, setSelectedAmusementGroup] = useState(null);
  const [services, setServices] = useState([]);
  const [loadingImage, setLoadingImage] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [reserveItemGroups, setReserveItemGroups] = useState([]);
  const [reserveItems, setReserveItems] = useState([]);
  const [reserveDetail, setReserveDetail] = useState({
    service: null,
    reserveDetailJson: null,
  });
  const [reserveDescriptions, setReserveDescriptions] = useState([]);
  const [showMessage, setShowMessage] = useState(false);
  const [showMessageEmptySelectBox, setShowMessageEmptySelectBox] =
    useState(false);
  const [loadingSearchReserveItem, setLoadingSearchReserveItem] =
    useState(true);
  const [
    selectedAmusementGroupLoadingData,
    setSelectedAmusementGroupLoadingData,
  ] = useState(false);
  const [basket, setBasket] = useState();
  const [dates, setDates] = useState([]);
  const [todayDate, setTodayDate] = useState("");
  const defaultList = [1, 2, 3, 4];
  const ctx = useContext(ContextApp);
  const {
    control,
    handleSubmit,
    getValues,
    setValue,
    register,
    resetField,
    reset,
    watch,
    clearErrors,
    formState: { isSubmitting, errors },
  } = useForm();
  const selectStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 10000,
    }),
  };
  //********پیش فرض تاریخ امروز ست بشه */
  useEffect(() => {
    const today = new Date();
    const thirtyDaysFromNow = new Date(today);
    thirtyDaysFromNow.setDate(today.getDate() + 30);
    const toJalaali = (date) => {
      const jDate = jalaali.toJalaali(date);
      return `${jDate.jy}/${("0" + jDate.jm).slice(-2)}/${("0" + jDate.jd).slice(-2)}`;
    };
    const formattedToday = toJalaali(today);
    setTodayDate(formattedToday);
    setValue("dateTimeStart", formattedToday);
  }, []);

  useEffect(() => {
    (async () => {
      try {
        setSelectedAmusementGroup(null);
        setAmusementGroupsLoadindData(true);
        const amusementGroups = await ApiAmusementService.getAllAmusementGroups(
          {
            cityId: ctx.selectedCity?.id,
          }
        );
        setAmusementGroups(amusementGroups);

        setAmusementGroupsLoadindData(false);
      } catch (error) {
        setAmusementGroupsLoadindData(false);
        console.log("error => ", error);
      }
    })();
  }, [ctx.selectedCity?.id]);
  // useEffect(() => {}, [flag]);
  /***انتخاب دسته یا مجموعه*********************/
  const handleAmusementGroupClick = async (group) => {
    window.scrollTo(0, 0);
    setSelectedService(null);
    try {
      setSelectedAmusementGroupLoadingData(true);
      const amusementServicesByGroupId =
        await ApiAmusementService.getAllServicesByGroupId({
          groupId: group.id,
          cityId: ctx.selectedCity?.id,
        });

      setSelectedAmusementGroupLoadingData(false);
      setSelectedAmusementGroup(group.id);

      setServices(amusementServicesByGroupId);
    } catch (error) {
      setSelectedAmusementGroupLoadingData(false);
      console.log("error =>", error);
    }
  };
  /***انتخاب سرویس*********************/
  const handleAmusementServiceClick = (amusement) => {
    setSelectedService(amusement.id);
    const selectedServiceId = amusement.id;
    const selectedServiceName = amusement.name;
    //console.log("amusement", amusement);

    // if (
    //   amusement.id === 1162 ||
    //   amusement.id === 5164 ||
    //   amusement.id === 5165 ||
    //   amusement.id === 5166 ||
    //   amusement.id === 5167 ||
    //   amusement.id === 5166 ||
    //   amusement.id === 5168 ||
    //   amusement.id === 5169 ||
    //   amusement.id === 6164 ||
    //   amusement.id === 6165 ||
    //   amusement.id === 6166 ||
    //   amusement.id === 6167 ||
    //   amusement.id === 6168 ||
    //   amusement.id === 6169
    // ) {
    //   navigate(`/concert`, {
    //     state: { selectedServiceId, selectedServiceName },
    //   });
    // }
    setValue("formSelectedAmusementGroup", {
      value: selectedAmusementGroup,
      label:
        amusementGroups.find((s) => s.id === selectedAmusementGroup)?.title ||
        "نامشخص",
    });
    setValue("formSelectedAmusementService", {
      value: amusement.id,
      label: services.find((s) => s.id === amusement.id)?.name || "نامشخص",
    });
    handleSubmit(handleSearchReserveItems)();
  };
  /***   سلکت باکس انتخاب دسته*************/
  const changeAmusementGroup = async (group) => {
    try {
      setValue("formSelectedAmusementGroup", group);
      setValue("formSelectedAmusementService", null);
      setSelectedAmusementGroupLoadingData(true);
      const groupId = group.value;
      const amusementServicesByGroupId =
        await ApiAmusementService.getAllServicesByGroupId({
          groupId: groupId,
          cityId: ctx.selectedCity?.id,
        });
      setSelectedAmusementGroup(groupId);
      setSelectedAmusementGroupLoadingData(false);
      setServices(amusementServicesByGroupId);
      // if (!subCategorySelect)
      //   setSubCategorySelect(amusementServicesByGroupId[0]?.amusementServiceId);
    } catch (error) {
      setSelectedAmusementGroupLoadingData(false);
      console.log("error =>", error);
    }
  };

  //****دکمه جستجو */
  const handleSearchReserveItems = async (data) => {
    //return;
    if (_.isNil(data?.formSelectedAmusementService?.value)) {
      setShowMessageEmptySelectBox(true);
      setLoadingSearchReserveItem(false);
    } else {
      setLoadingSearchReserveItem(true);
      setShowMessageEmptySelectBox(false);
      //setFlag(false);
      //flag = false;
      if (
        data.dateTimeStart !== null &&
        typeof data.dateTimeStart === "object"
      ) {
        data.dateTimeStart = tools.DateFormat(data.dateTimeStart);
      }
      var selectedAmusementId = data?.formSelectedAmusementService?.value;
      setSelectedService(selectedAmusementId);
      const response = _.isEmpty(data.dateTimeStart)
        ? await ApiAmusementService.getReserveDetails({
            id: selectedAmusementId,
          })
        : await ApiAmusementService.getReserveDetails({
            id: selectedAmusementId,
            startDate: data.dateTimeStart.replaceAll("/", ""),
          });
      // console.log("response==", response);

      setDates(response.fullDateTimeDtos);

      if (!_.isEmpty(response.reserveDetail_V2Descriptions)) {
        const descriptionsObject = JSON.parse(
          response.reserveDetail_V2Descriptions
        );
        setReserveDescriptions(descriptionsObject);
      }

      //جستجو برای تاریخی که داخل سلکت باکس هست که اگه نبود پیام نمایش بده
      // تبدیل تاریخ انتخاب شده به فرمت YYYYMMDD برای مقایسه
      const selectDate = data.dateTimeStart.replaceAll("/", "");
      
      // محاسبه یک ماه بعد از تاریخ انتخابی
      const startDate = moment(data.dateTimeStart, "jYYYY/jMM/jDD");
      const endDate = startDate.clone().add(1, "month");
      
      function findAnyMatchInRange(data, start, end) {
        const arr = Array.isArray(data) ? data : [data];
      
        for (let obj of arr) {
          if (obj.reserveDetail_V2) {
            const vsArray = JSON.parse(obj.reserveDetail_V2);
      
            // پیدا کردن هر آیتمی که بین start و end باشه
            const found = vsArray.find((item) => {
              if (!item.dIA) return false;
      
              // item.d فرمت YYYYMMDD داره
              const itemDate = moment(item.d, "jYYYYjMMjDD");
              return itemDate.isBetween(start, end, "day", "[]"); // شامل ابتدا و انتها
            });
      
            if (found) return found;
          }
        }
      
        return null;
      }
      
      // اگر چیزی پیدا نشد => پیام نمایش داده بشه
      if (findAnyMatchInRange(response, startDate, endDate) === null) {
        setShowMessage(true);
      } else {
        setShowMessage(false);
        }
        setLoadingSearchReserveItem(false);
        if (!_.isEmpty(response.reserveDetail_V2)) {
            const reserveDetailObject = JSON.parse(response.reserveDetail_V2);
            if (_.isEmpty(reserveDetailObject)) {
                setShowMessage(true);
            } else {
                setReserveDetail({
                    service: selectedService,
                    reserveDetailJson: reserveDetailObject,
                });
                //setShowMessage(false);
            }
        } else {
            // setShowMessage(true);
            //flag = false;
        }
      
      if (!_.isEmpty(response)) {
        setReserveItems(response.amusementServiceReserveItems);
        setReserveItemGroups(response.amusementServiceReserveItemGroups);
      }
    }
  };

  //*********تغییر در تعداد */
  const handleChangeCountSelect = async (
    itemCount,
    reserveItemGroup,
    reserveItem,
    selectedDate,
    maxCount,
    minCount
  ) => {
    //*************افزودن سبد به لوکال استوریج */
    const reserveItemSelected = reserveItems.find(
      (s) => s.id === reserveItem.id
    );
    const groupSelected = reserveItemGroups.find(
      (s) => s.id === reserveItemGroup.id
    );
    const serviceSelected = services.find((s) => s.id === selectedService);
    let personLists = [];
    for (let i = 0; i < itemCount; i++) {
      personLists.push({ personFullName: " ", id: 0, indexId: 1 });
    }
    const details = [];
    details.push({
      id: reserveItemGroup.id,
      text: reserveItemGroup.title,
      originalPrice: 0,
      price: 0,
      type: "group",
    });
    details.push({
      id: reserveItem.id,
      text: reserveItem.title,
      originalPrice: _.toNumber(reserveItem.originalPrice),
      price: _.toNumber(reserveItem.price),
      type: "item",
    });
    await BasketHelper.addItemToBasket(
      ctx,
      _.toNumber(itemCount),
      reserveItem.originalPrice, //_.toString(sumOriginalPrice),
      reserveItem.price, //_.toString(sumPrice),
      serviceSelected.id,
      serviceSelected.name,
      serviceSelected.imageUrl,
      null,
      "",
      selectedDate,
      JSON.stringify(details),
      //await BasketHelper.addBasketPersonList(ctx, personLists),//تغییر دادم!
      personLists,
      0, // props.reserveDetails.Id,
      reserveItem.id,
      reserveItemGroup.id,
      reserveItem.agentPaidAmount,
      reserveItem.commissionAmount,
      maxCount,
      minCount
    );
    //************************نمایش پیغام های لازم */
    if (itemCount > 0) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success px-5 py-2 mr-2",
          cancelButton: "btn btn-outline-success py-2  px-5",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          // title: "آیتم زیر به سبد خرید اضافه شد",
          showClass: {
            popup: `
          animate__animated
          animate__fadeIn
          animate__faster            `,
          },
          hideClass: {
            popup: `
          animate__animated
          animate__fadeOut
          animate__faster            `,
          },
          icon: "success",
          html:
            "<div class='fw-bold mb-4 fs-large'>آیتم زیر به سبد خرید اضافه شد</div>" +
            "<div class='border rounded-3 px-3 py-2'>" +
            "<div class='row'>" +
            "<div class='col align-items-center py-2 text-end fw-bold' >" +
            serviceSelected.name +
            "<div class='fs-small py-2 text-end'>" +
            groupSelected.title +
            " " +
            reserveItemSelected.title +
            "</div>" +
            "<div class='fs-small text-danger text-end'><span class='fw-normal'> تاریخ استفاده : </span>" +
            selectedDate +
            "</div>" +
            "</div>" +
            "<div class='col-auto border-end fw-bold fs-large text-end my-auto'>" +
            itemCount +
            " عدد " +
            "</div>" +
            "</div></div>",
          type: "success",
          showConfirmButton: true,
          preConfirm: () => {
            navigate("/basket");
          },
          confirmButtonText: "   مشاهده سبد خرید  ",

          showCancelButton: true,
          cancelButtonText: "   اضافه کردن سایر تفریحات ",
        })
        .then((result) => {
          // if (result.value) {
          //   var rest = AgentWithdrawal.removeAgentWithdrawal({ Id: ReqId }).then(
          //     (result) => {
          //       SwalMessage({ title: result.message, iSsuccess: result.data });
          //       callback();
          //     }
          //   );
          // }
        });
    } else {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success px-5 py-2 mr-2",
          cancelButton: "btn btn-outline-success py-2  px-5",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          // title: "آیتم زیر به سبد خرید اضافه شد",
          showClass: {
            popup: `
          animate__animated
          animate__fadeIn
          animate__faster            `,
          },
          hideClass: {
            popup: `
          animate__animated
          animate__fadeOut
          animate__faster            `,
          },
          icon: "success",
          html: "<div class='fw-bold mb-4 fs-large'> این آیتم از سبد خرید حذف شد</div>",
          type: "success",
          showConfirmButton: false,

          showCancelButton: true,
          cancelButtonText: " متوجه شدم",
        })
        .then((result) => {
          //if (result.value) BasketHelper.deletebasketItem(ctx, basketItem);
        });
    }
  };
  /************************ */
  useEffect(() => {
    (async () => {
      let basketTemp = await BasketHelper.getBasketFromStorage(ctx);
      if (!_.isEmpty(basketTemp)) {
        setBasket(basketTemp);
      }
    })();
  }, [ctx.basketInfo]);

  // console.log("showmessage", showMessage);
  /******************************** */
  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header  pb-3 pt-5 mb-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              دسته بندی تفریحات {ctx.selectedCity?.name}
              <span className="fw-normal   font-size-sm">
                <span>{selectedService ? " / فرم رزرو " : ""}</span>
              </span>
            </span>
          </h3>
          <div className="card-toolbar"></div>
        </div>
        {/*Start body */}
        <div className="card-body pt-3">
          <Row>
            {/* نمایش دسته ها یا مجموعه ها */}
            {!selectedAmusementGroup ? (
              <>
                {!amusementGroupsLoadindData ? (
                  amusementGroups.length > 0 ? (
                    amusementGroups?.map((group) => (
                      <Col
                        xs="12"
                        sm="6"
                        md="4"
                        xl="3"
                        key={group.id}
                        className="mb-3 px-2 text-center"
                      >
                        <Card
                          className="rounded-4 shadow-sm h-100"
                          onClick={() => handleAmusementGroupClick(group)}
                        >
                          <Card.Body className="pb-0 pt-2 px-5">
                            <img
                              src={
                                process.env.REACT_APP_PHOTOPATH_WEB +
                                group.imageUrl
                              }
                              alt=""
                              height="100px"
                            />
                            <h5 className="fw-bold mt-4 border-top pt-4 mb-3">
                              {group.title}{" "}
                            </h5>
                          </Card.Body>
                          <Card.Footer className="bg-transparent border-top-0 pt-0">
                            <Card.Text>
                              <span className="font-weight-bold">
                                {group.amusementServicesCount}
                              </span>{" "}
                              تفریح ثبت شده
                            </Card.Text>
                            <Button
                              variant="primary"
                              className="px-5 hover-rounded"
                            >
                              مشاهده تفریحات{" "}
                            </Button>
                          </Card.Footer>
                        </Card>
                      </Col>
                    ))
                  ) : (
                    <div className="w-100">
                      <div className="bg-light-primary border border-primary rounded-3 px-5 py-3 d-inline-flex text-primary w-auto mb-5">
                        {" "}
                        تفریحاتی برای رزرو وجود ندارد.
                      </div>
                    </div>
                  )
                ) : (
                  defaultList?.map(() => (
                    <SkeletonTheme>
                      <Col
                        xs="12"
                        sm="6"
                        md="4"
                        xl="3"
                        // key={group.id}
                        className="mb-3 px-2 text-center"
                      >
                        <Card className="rounded-4 shadow-sm h-100">
                          <Card.Body className="pb-0 pt-2 px-5">
                            <Skeleton width="100%" height="100px"></Skeleton>

                            <h5 className="fw-bold mt-4 border-top pt-4 mb-3">
                              <Skeleton width="100%" height="15px"></Skeleton>
                            </h5>
                          </Card.Body>
                          <Card.Footer className="bg-transparent border-top-0 pt-0">
                            <Card.Text>
                              <Skeleton width="100%" height="15px"></Skeleton>
                            </Card.Text>
                            <Skeleton width="125px" height="39px"></Skeleton>
                          </Card.Footer>
                        </Card>
                      </Col>
                    </SkeletonTheme>
                  ))
                )}
              </>
            ) : !selectedService ? (
              <>
                {/* نمایش زیردسته یا زیرمجموعه */}
                <h5
                  onClick={() => setSelectedAmusementGroup(null)}
                  style={{ cursor: "pointer" }}
                  className="pb-5"
                >
                  <ArrowRight /> بازگشت به دسته بندی{" "}
                </h5>
                {amusementGroups?.length > 0
                  ? !selectedAmusementGroupLoadingData
                    ? services?.map((service, index) => (
                        <Col
                          xs="12"
                          sm="6"
                          md="4"
                          xl="3"
                          key={service.id}
                          className="mb-3 px-2 text-center col-xl-5th "
                        >
                          <Card className="rounded-4 shadow-sm h-100">
                            <Card.Body className="pb-3 pt-4 px-4">
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                {/* اسکلتون / عکس پیشفرض */}
                                {!loadingImage && (
                                  <Skeleton
                                    width="100%"
                                    height="150px"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                    }}
                                  ></Skeleton>
                                  // <Card.Img
                                  //   variant="top"
                                  //   src="/media/bg/load-image.jpg"
                                  //   alt="loading"
                                  //   style={{
                                  //     display: "block",
                                  //     minHeight: "180px",
                                  //     objectFit: "cover",
                                  //   }}
                                  // />
                                )}

                                {/* عکس اصلی */}
                                <img
                                  src={
                                    process.env.REACT_APP_PHOTOPATH_WEB +
                                    service.imageUrl
                                  }
                                  alt={service.name}
                                  className="w-100 rounded-3"
                                  style={{
                                    objectFit: "cover",
                                    height: loadingImage ? "100%" : "150px",
                                    opacity: loadingImage ? 1 : 0,
                                    transition: "opacity 0.5s ease-in-out",
                                    minHeight: "130px",
                                  }}
                                  onLoad={() => setLoadingImage(true)}
                                />
                              </div>
                              <Card.Title className="mb-1 mt-5">
                                {service.name}
                              </Card.Title>
                            </Card.Body>
                            <Card.Footer className="bg-transparent border-top-0 pt-0 px-xl-3">
                              <Button
                                variant="primary"
                                className="px-5 px-lg-3 px-xl-3 hover-rounded"
                                onClick={() =>
                                  handleAmusementServiceClick(service)
                                }
                              >
                                مشاهده سانس و رزرو{" "}
                              </Button>
                            </Card.Footer>
                          </Card>
                        </Col>
                      ))
                    : defaultList?.map(() => (
                        <SkeletonTheme>
                          <Col
                            xs="12"
                            sm="6"
                            md="4"
                            xl="3"
                            className="mb-3 px-2 text-center col-xl-5th "
                          >
                            <Card className="rounded-4 shadow-sm h-100">
                              <Card.Img
                                variant="top"
                                className="rounded-4  rounded-bottom-0"
                                as={Skeleton}
                                height={150}
                              />

                              <Card.Body className="pb-3 pt-4">
                                <Card.Title className="mb-1 ">
                                  <Skeleton
                                    width="100%"
                                    height="15px"
                                  ></Skeleton>
                                </Card.Title>
                              </Card.Body>
                              <Card.Footer className="bg-transparent border-top-0 pt-0">
                                <Skeleton
                                  width="125px"
                                  height="39px"
                                ></Skeleton>
                              </Card.Footer>
                            </Card>
                          </Col>
                        </SkeletonTheme>
                      ))
                  : "تفریحی وجود ندارد"}
              </>
            ) : (
              <>
                {/************  فرم جستجو ********************************/}
                <form
                  noValidate
                  autoComplete="off"
                  onSubmit={handleSubmit(handleSearchReserveItems)}
                >
                  <Row>
                    <Col sm md className="px-0 pr-sm-3">
                      <FormControl variant="standard" className="w-100 mx-0">
                        <Controller
                          name="formSelectedAmusementGroup"
                          control={control}
                          render={({ field }) => (
                            <SelectComponent
                              className="mt-0 mb-5 mb-md-0 w-100"
                              placeholder="انتخاب دسته"
                              styles={selectStyles}
                              options={amusementGroups?.map((item) => ({
                                value: item.id,
                                label: item.title,
                              }))}
                              field={field}
                              onChange={changeAmusementGroup}
                            />
                            // <Select
                            //   value={value}
                            //   styles={selectStyles}
                            //   inputId="react-select-with-search"
                            //   className="mb-5 mb-md-0 w-100"
                            //   variant="outlined"
                            //   placeholder="انتخاب دسته"
                            //   options={amusementGroups.map((item) => ({
                            //     value: item.id,
                            //     label: item.title,
                            //   }))}
                            //   onChange={changeAmusementGroup}
                            // />
                          )}
                        />
                      </FormControl>{" "}
                    </Col>
                    <Col sm md className="px-0 pr-sm-3">
                      <Controller
                        name="formSelectedAmusementService"
                        control={control}
                        render={({ field }) => (
                          <SelectComponent
                            className="mt-0 mb-5 mb-md-0 w-100 border-danger"
                            placeholder="انتخاب سرویس"
                            styles={selectStyles}
                            isError={showMessageEmptySelectBox}
                            options={services?.map((item) => ({
                              value: item.id,
                              label: item.name,
                            }))}
                            field={field}
                          />
                          // <Select
                          //   value={value}
                          //   onChange={onChange}
                          //   styles={selectStyles}
                          //   error={!!errors.formSelectedAmusementService}
                          //   inputId="react-select-with-search"
                          //   className="mb-5 mb-md-0 w-100"
                          //   variant="outlined"
                          //   placeholder="انتخاب سرویس"
                          //   options={services.map((item) => ({
                          //     value: item.id,
                          //     label: item.name,
                          //   }))}
                          // />
                        )}
                      />
                    </Col>
                    <Col sm="3" md className="px-0 pr-sm-3">
                      <Controller
                        name="dateTimeStart"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <ShamsiDatePicker
                            className=""
                            value={value}
                            onChange={onChange}
                            placeholder="تاریخ"
                            minDate={new DateObject({ calendar: persian })}
                          />
                        )}
                      />
                    </Col>

                    <Col sm="auto" className="px-0">
                      <Button
                        variant="danger"
                        className=" px-4 rounded-3 py-3 text-white mt-3 mt-sm-0"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting && (
                          <Spinner
                            animation="border"
                            variant="warning"
                            size="sm"
                          />
                        )}
                        <SearchRoundedIcon /> جستجو
                      </Button>
                    </Col>
                  </Row>
                </form>

                {loadingSearchReserveItem ? (
                  <div className="py-3 text-primary px-0">
                    <SkeletonReserveItem />
                  </div>
                ) : showMessageEmptySelectBox ? (
                  <div className="bg-light-danger border border-danger rounded-3 px-5 py-3 d-inline-flex text-danger w-auto mt-4 mb-5">
                    لطفا سرویس را انتخاب نمایید
                  </div>
                ) : (
                  <>
                    {showMessage ? (
                      <div className="bg-light-primary border border-primary rounded-3 px-5 py-3 d-inline-flex text-primary w-auto mb-5 mt-5">
                        در این بازه آیتمی برای رزرو وجود ندارد
                      </div>
                    ) : (
                      <ul className="mt-4 px-0" style={{ listStyle: "none" }}>
                        {dates?.map(function (date, index) {
                          const nameDate = date.date;
                          const nameDate2 = nameDate.replaceAll("/", "");
                          let reserveDetailDate = _.isArray(
                            reserveDetail.reserveDetailJson
                          )
                            ? _.find(reserveDetail.reserveDetailJson, {
                                d: nameDate.replaceAll("/", ""),
                              })
                            : "";
                          let isItemActive =
                            reserveDetailDate && reserveDetailDate.dIA
                              ? true
                              : false;
                          const dateDescription = _.find(
                            reserveDescriptions,
                            (item) =>
                              _.toString(item.id) ===
                              _.toString(reserveDetailDate?.dDesId)
                          );
                          if (
                            !_.isEmpty(reserveItemGroups) &&
                            !_.isEmpty(reserveItems) &&
                            isItemActive
                          )
                            return (
                              <li
                                key={index}
                                className=" mb-5 border rounded-4 border-dark-blue bg-light-blue"
                              >
                                <div className="font-weight-bold bg-dark-blue pb-2 pt-4 pl-2 font-size-lg rounded-4 text-white rounded-bottom-0">
                                  <CalendarmonthOutlined /> {nameDate}
                                  {!_.isEmpty(dateDescription) && (
                                    <Tooltip
                                      title={dateDescription?.desc}
                                      arrow
                                    >
                                      <span className="text-white px-1">
                                        <InfoOutlinedIcon />
                                      </span>
                                    </Tooltip>
                                  )}
                                </div>
                                {reserveItemGroups?.map(
                                  function (reserveItemGroup, index) {
                                    // if (!flag) {
                                    //   flag = true;
                                    // }
                                    const reserveDetailGroup =
                                      reserveDetailDate?.g?.filter(
                                        (g) => g.gId === reserveItemGroup.id
                                      )[0];
                                    const groupDescription = _.find(
                                      reserveDescriptions,
                                      (item) =>
                                        _.toString(item.id) ===
                                        _.toString(reserveDetailGroup?.gDesId)
                                    );
                                    const group_ReceptionHoursAreOver =
                                      todayDate == date.date &&
                                      _.toInteger(date.hour + date.minute) >
                                        _.toInteger(
                                          _.split(
                                            reserveItemGroup.reservationExpirationTime,
                                            ":"
                                          )[0] +
                                            _.split(
                                              reserveItemGroup.reservationExpirationTime,
                                              ":"
                                            )[1]
                                        );
                                    if (
                                      !_.isEmpty(reserveDetailGroup) &&
                                      reserveDetailGroup.gID &&
                                      reserveItemGroup.isActive
                                    )
                                    {
                                      // فیلتر آیتم‌های معتبر برای نمایش
                                      const validReserveItems = reserveItems?.filter((reserveItem) => {
                                        const item = _.find(reserveDetailGroup.i, { iId: reserveItem.id });
                                        return (
                                          !_.isNil(item) &&
                                          item.iID &&
                                          reserveItem.isActive
                                        );
                                      });
                                    
                                      // اگه هیچ آیتمی برای نمایش وجود نداره
                                      if (_.isEmpty(validReserveItems)) return null;
                                      return (
                                        <div
                                          className={classNames(
                                            "border border-light-blue bg-white rounded-4 pb-3 px-4 m-3 mb-4"
                                          )}
                                        >
                                          <Row
                                            key={reserveDetailGroup.gId}
                                            className="font-weight-bold border-bottom mb-3 pt-4 rounded-4 rounded-bottom-0 pb-5"
                                          >
                                            <Col className="text-danger">
                                              <ArrowLeftOtline />{" "}
                                              {reserveItemGroup.title}
                                              {!_.isEmpty(groupDescription) && (
                                                <Tooltip
                                                  title={groupDescription?.desc}
                                                  arrow
                                                >
                                                  <span className="text-dark-blue px-1">
                                                    <InfoOutlinedIcon />
                                                  </span>
                                                </Tooltip>
                                              )}
                                                 {!_.isEmpty(reserveItemGroup.tooltip) && (
                                                <Tooltip
                                                  title={
                                                    <div dangerouslySetInnerHTML={{ __html: reserveItemGroup.tooltip }} />
                                                  }
                                                  arrow
                                                >
                                                  <span className="text-dark-blue px-1">
                                                    <InfoOutlinedIcon />
                                                  </span>
                                                </Tooltip>
                                              )}
                                            </Col>
                                          </Row>

                                          {validReserveItems.map((reserveItem) => {
                                              const reserveDetailItem = _.find(reserveDetailGroup.i, {
                                                iId: reserveItem.id,
                                              });
                                              const item = _.find(
                                                reserveDetailGroup.i,
                                                {
                                                  iId: reserveItem.id,
                                                }
                                              );
                                              const item_ReceptionHoursAreOver =
                                                todayDate == date.date &&
                                                _.toInteger(
                                                  date.hour + date.minute
                                                ) >
                                                  _.toInteger(
                                                    _.split(
                                                      reserveItem.reservationExpirationTime,
                                                      ":"
                                                    )[0] +
                                                      _.split(
                                                        reserveItem.reservationExpirationTime,
                                                        ":"
                                                      )[1]
                                                  );
                                              const itemBasketCount = _.find(
                                                basket?.basketItemTemps,
                                                {
                                                  isDeleted: false,
                                                  amusementServiceReserveItemGroupId:
                                                    reserveItemGroup.id,
                                                  amusementServiceReserveItemId:
                                                    reserveItem.id,
                                                  checkInDate: date.date,
                                                }
                                              )?.totalCount;

                                              // console.log(
                                              //   "basket?.basketItemTemps",
                                              //   basket?.basketItemTemps
                                              // );
                                              // console.log(
                                              //   "dates[0].date",
                                              //   date.date
                                              // );
                                              // console.log(
                                              //   "itemBasketCount",
                                              //   itemBasketCount
                                              // );
                                              if (
                                                !_.isNil(item) &&
                                                item.iID &&
                                                reserveItem.isActive
                                              )
                                                return (
                                                  <Row
                                                    className={classNames(
                                                      "py-4 py-xl-0  border-bottom item-box",
                                                      itemBasketCount > 0
                                                        ? "active-row"
                                                        : "",
                                                      reserveItem.isFullCapacity ||
                                                        item.iIFC ||
                                                        group_ReceptionHoursAreOver ||
                                                        item_ReceptionHoursAreOver ||
                                                        !item.iIA ||
                                                        !reserveItem.isActive
                                                        ? "opacity-50"
                                                        : ""
                                                    )}
                                                    key={reserveItem.id}
                                                  >
                                                    <Col
                                                      xl="3"
                                                      className="mb-3 my-xl-auto py-xl-4"
                                                    >
                                                      {reserveItem.title }
                                                      {!_.isEmpty(reserveItem.tooltip) && (
                                                        <Tooltip
                                                        title={
                                                          <div dangerouslySetInnerHTML={{ __html: reserveItem.tooltip }} />
                                                        }
                                                          arrow
                                                        >
                                                          <span className="text-dark-blue px-1">
                                                            <InfoOutlinedIcon />
                                                          </span>
                                                        </Tooltip>
                                                      )}
                                                    </Col>
                                                    <Col
                                                      sm
                                                      md
                                                      xl
                                                      className="mt-3 mt-xl-0 ps-sm-0 py-xl-4"
                                                    >
                                                      <Row>
                                                        <Col
                                                          xs="6"
                                                          sm="12"
                                                          className="font-size-xs text-secondary mb-md-2"
                                                        >
                                                          نرخ مصوب
                                                        </Col>
                                                        <Col
                                                          xs="6"
                                                          sm="12"
                                                          className="text-start text-sm-end mt-sm-2 mt-xl-0 text-decoration-line-through"
                                                        >
                                                          <SplitNumber
                                                            number={
                                                              reserveItem.originalPrice
                                                            }
                                                          />
                                                          <span className="font-size-sm pl-1">
                                                            تومان
                                                          </span>
                                                        </Col>
                                                      </Row>
                                                    </Col>
                                                    <Col
                                                      sm
                                                      md
                                                      xl
                                                      className="mt-3 mt-xl-0 ps-sm-0 py-xl-4"
                                                    >
                                                      <Row>
                                                        <Col
                                                          xs="6"
                                                          sm="12"
                                                          className="font-size-xs text-secondary mb-md-2"
                                                        >
                                                          نرخ فروش
                                                        </Col>
                                                        <Col
                                                          xs="6"
                                                          sm="12"
                                                          className="text-start text-sm-end mt-sm-2 mt-xl-0"
                                                        >
                                                          <SplitNumber
                                                            number={
                                                              reserveItem.price
                                                            }
                                                          />
                                                          <span className="font-size-sm pl-1">
                                                            تومان
                                                          </span>
                                                        </Col>
                                                      </Row>
                                                    </Col>
                                                    <Col
                                                      sm
                                                      md
                                                      className="mt-3 mt-xl-0 ps-sm-0 py-xl-4"
                                                    >
                                                      <Row>
                                                        <Col
                                                          sm="12"
                                                          xs="6"
                                                          className="font-size-xs text-secondary mb-md-2"
                                                        >
                                                          کمیسیون
                                                        </Col>
                                                        <Col
                                                          sm="12"
                                                          xs="6"
                                                          className="text-start  text-sm-end  mt-sm-2 mt-xl-0"
                                                        >
                                                          <SplitNumber
                                                            number={
                                                              reserveItem.commissionAmount
                                                            }
                                                          />
                                                          <span className="font-size-sm pl-1">
                                                            تومان
                                                          </span>
                                                        </Col>
                                                      </Row>
                                                    </Col>
                                                    <Col
                                                      sm
                                                      md
                                                      xl
                                                      className="mt-3 mt-xl-0 ps-sm-0 py-xl-4"
                                                    >
                                                      <Row>
                                                        <Col
                                                          sm="12"
                                                          xs="6"
                                                          className="font-size-xs text-dark-blue mb-md-2"
                                                        >
                                                          <PaymentsOutline />{" "}
                                                          مبلغ قابل پرداخت
                                                        </Col>
                                                        <Col
                                                          sm="12"
                                                          xs="6"
                                                          className="font-weight-bold text-dark-blue font-size-lg text-start text-sm-end mt-sm-2 mt-xl-0"
                                                        >
                                                          <SplitNumber
                                                            number={
                                                              reserveItem.agentPaidAmount
                                                            }
                                                          />
                                                          <span className="font-size-sm pl-1">
                                                            تومان
                                                          </span>
                                                        </Col>
                                                      </Row>
                                                    </Col>
                                                    <Col
                                                      sm="1"
                                                      md="2"
                                                      lg="1"
                                                      xl="1"
                                                      className="mt-3 mt-xl-0 ps-sm-0 pl-sm-2 py-xl-4"
                                                    >
                                                      <Row>
                                                        <Col
                                                          sm="12"
                                                          xs="6"
                                                          className="font-size-xs text-secondary mb-md-2"
                                                        >
                                                          موجودی
                                                        </Col>
                                                        <Col
                                                          sm="12"
                                                          xs="6"
                                                          className="text-start text-sm-end mt-sm-2 mt-xl-0"
                                                        >
                                                          {reserveDetailItem?.iC
                                                            ? reserveDetailItem.iC
                                                            : reserveItem.defaultReserveCountPerDay}
                                                        </Col>
                                                      </Row>
                                                    </Col>
                                                    <Col
                                                      sm
                                                      md
                                                      xl
                                                      className="mt-3 mt-xl-0 py-xl-4"
                                                    >
                                                      {/* ******** */}
                                                      <Row>
                                                        <Col
                                                          sm="12"
                                                          xs="6"
                                                          className="font-size-xs text-secondary my-auto mb-md-2"
                                                        >
                                                          تعداد
                                                        </Col>
                                                        <Col
                                                          sm="12"
                                                          xs="6"
                                                          className="text-start text-sm-end mt-sm-2 mt-xl-0"
                                                        >
                                                          {reserveItem.isFullCapacity ||
                                                          item.iIFC ? (
                                                            <div
                                                              className="font-size-xs "
                                                              style={
                                                                {
                                                                  // width: "80px",
                                                                }
                                                              }
                                                            >
                                                              <IconPeople width="16px" />
                                                              تکمیل ظرفیت
                                                            </div>
                                                          ) : group_ReceptionHoursAreOver ||
                                                            item_ReceptionHoursAreOver ? (
                                                            <div
                                                              className=" font-size-xs "
                                                              style={
                                                                {
                                                                  // width: "80px",
                                                                }
                                                              }
                                                            >
                                                              <IconHourGlass width="16px" />
                                                              اتمام ساعت پذیرش
                                                            </div>
                                                          ) : !item.iIA ||
                                                            !reserveItem.isActive ? (
                                                            <div
                                                              className=" font-size-xs "
                                                              style={
                                                                {
                                                                  // width: "80px",
                                                                }
                                                              }
                                                            >
                                                              <IconForbidden width="16px" />
                                                              عدم فعالیت
                                                            </div>
                                                          ) : !_.isEmpty(
                                                              reserveItem.reservationByPhone
                                                            ) ? (
                                                            <a
                                                              href={`tel:${reserveItem.reservationByPhone}`}
                                                              className=" font-size-xs d-inline-block rounded-2 py-1 px-1"
                                                              style={{
                                                                // width: "80px",
                                                                color:
                                                                  "#ed7070",
                                                                border:
                                                                  "1px solid rgb(237 112 112 / 30%)",
                                                                backgroundColor:
                                                                  "rgb(237 112 112 / 12%)",
                                                              }}
                                                            >
                                                              <div className="flipX small-svg d-inline-block">
                                                                <IconPhone
                                                                  fill="rgb(237, 112, 112)"
                                                                  width="16px"
                                                                />
                                                              </div>
                                                              رزرو تلفنی
                                                            </a>
                                                          ) : (
                                                            <>
                                                              <select
                                                                className="form-select form-select-rtl"
                                                                value={
                                                                  _.isNil(
                                                                    itemBasketCount
                                                                  )
                                                                    ? 0
                                                                    : itemBasketCount
                                                                }
                                                                onChange={(
                                                                  event
                                                                ) =>
                                                                  handleChangeCountSelect(
                                                                    event.target
                                                                      .value,
                                                                    reserveItemGroup,
                                                                    reserveItem,
                                                                    nameDate,
                                                                    reserveDetailItem.iC
                                                                      ? reserveDetailItem.iC
                                                                      : reserveItem.defaultReserveCountPerDay,
                                                                    reserveDetailItem.iMinC
                                                                  )
                                                                }
                                                              >
                                                                {" "}
                                                                {[
                                                                  ...Array(
                                                                    _.toInteger(
                                                                      reserveDetailItem.iC
                                                                    ) + 1
                                                                  ),
                                                                ].map(
                                                                  (x, i) =>
                                                                    (i >=
                                                                      reserveDetailItem.iMinC ||
                                                                      i ==
                                                                        0) && (
                                                                      <option
                                                                        value={
                                                                          i
                                                                        }
                                                                      >
                                                                        {i}
                                                                      </option>
                                                                    )
                                                                )}
                                                              </select>
                                                            </>
                                                          )}
                                                        </Col>
                                                      </Row>
                                                    </Col>
                                                  </Row>
                                                );
                                            }
                                          )}
                                        </div>
                                      );
                                          }
                                  }
                                )}
                              </li>
                            );
                        })}
                      </ul>
                    )}
                  </>
                )}
                <div className="px-0">
                  <Button
                    variant="primary"
                    onClick={() => setSelectedService(null)}
                  >
                    بازگشت به صفحه قبل
                  </Button>
                </div>
              </>
            )}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Tourism;
